"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataSelectorId = exports.DEFAULT_TEXTS = exports.DEFAULT_TEXTS_MONTH = void 0;
exports.DEFAULT_TEXTS_MONTH = {
    shortSunday: 'Su',
    shortMonday: 'Mo',
    shortTuesday: 'Tu',
    shortWednesday: 'We',
    shortThursday: 'Th',
    shortFriday: 'Fr',
    shortSaturday: 'Sa'
};
exports.DEFAULT_TEXTS = Object.assign({ january: 'January', february: 'February', march: 'March', april: 'April', may: 'May', june: 'June', july: 'July', august: 'August', september: 'September', october: 'October', november: 'November', december: 'December', today: 'Today' }, exports.DEFAULT_TEXTS_MONTH);
exports.dataSelectorId = {
    prevMonthControl: 'prev-month-control',
    monthSelectorControl: 'selector-control',
    nextMonthControl: 'next-month-control',
    todayControl: 'today-control'
};
//# sourceMappingURL=constants.js.map